const createAuthentication = async ({ commit, rootGetters, dispatch }, payload) => {
  commit('SET_CREATE_CREDENTIALS_LOADING', true);
  try {
    const customer = rootGetters['customer/CUSTOMER'];
    const selected_customer = rootGetters['customer/SELECTED_CUSTOMER'];

    const data = {
      ...payload,
    };

    if (customer.customer_id === 0) {
      data.customer_id = selected_customer.customer_id;
    }

    const response = await window.axios.post('/proxy/credentials-manager', data);
    if (response && response.data.success) {
      commit('ADD_AUTHENTICATION_ITEM', response.data.created_group);
      // TODO: get all items here or continue as is
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
  } finally {
    // stuff here
    commit('SET_CREATE_CREDENTIALS_LOADING', false);
  }
};

export default createAuthentication;
